import { MembershipProfile } from '@models/membership/MembershipProfile'
import { SBAPI } from '@supplement-bacon/react-toolkit/utils'
import { TableParams } from '@supplement-bacon/sb-table-filters'
import { MEMBERSHIP_MEMBERSHIP_PROFILES_URL } from '@utils/urls'

const fetchMembershipProfiles = (params: TableParams) =>
  SBAPI.FetchPaginated<MembershipProfile[]>(
    MEMBERSHIP_MEMBERSHIP_PROFILES_URL,
    params
  )

const fetchMembershipProfileById = (id: number, params?: TableParams) =>
  SBAPI.Fetch<MembershipProfile>(
    `${MEMBERSHIP_MEMBERSHIP_PROFILES_URL}/${id}`,
    params
  )

const updateMembershipProfile = (membershipProfile: MembershipProfile) =>
  SBAPI.Put<MembershipProfile>(
    `${MEMBERSHIP_MEMBERSHIP_PROFILES_URL}/${membershipProfile.id}`,
    membershipProfile
  )

const updateMembershipProfileCardNumber = (
  membershipProfile: Partial<MembershipProfile>
) =>
  SBAPI.Put(
    `${MEMBERSHIP_MEMBERSHIP_PROFILES_URL}/${membershipProfile.id}/card-number`,
    { cardNumber: membershipProfile.cardNumber }
  )

const updateTagsForMembershipProfile = (
  membershipProfileId: number,
  tags: number[]
) =>
  SBAPI.Put(
    `${MEMBERSHIP_MEMBERSHIP_PROFILES_URL}/${membershipProfileId}/tags`,
    {
      tags,
    }
  )
const detachAppUserFromMembershipProfile = (membershipProfileId: number) =>
  SBAPI.Delete(
    `${MEMBERSHIP_MEMBERSHIP_PROFILES_URL}/${membershipProfileId}/detach-app-user`
  )

export {
  detachAppUserFromMembershipProfile,
  fetchMembershipProfileById,
  fetchMembershipProfiles,
  updateMembershipProfile,
  updateMembershipProfileCardNumber,
  updateTagsForMembershipProfile,
}
